import { createSelector } from "@reduxjs/toolkit";
import { selectChatMessages } from "./select-chat-messages";
import { selectAuthorList } from "./select-author-list";

export const selectLastMessageStatus = createSelector(
  selectChatMessages,
  selectAuthorList,
  (messages) => messages.slice(-1)[0]?.status
);
